module.exports = __webpack_public_path__ + "static/media/m4a-icon.3e910c7f.svg";